export function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
}

export function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

export function getGameTime(length, showMs=true) {
    let ms = Math.floor(length%1);
    let seconds = (Math.floor(length%60));
    let minutes = Math.floor(length / 60);
    
    if (minutes < 0) {
        return showMs ? "0:00.0" : "0:00";
    }
    
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    
    if (showMs) {
        return minutes + ':' + seconds + "." + ms;
    } else {
        return minutes + ':' + seconds;
    }
}

export function average(list) {
    let total = 0;
    for(let i=0; i<list.length; i++) {
        total += list[i];
    }
    return total / list.length;
}

export function getCharFilename(character, alt, color="gray") {
    return `https://skydereign.github.io/forglory-data/chars/${color}/${character}_${alt !== -1 ? alt : 0}.png`;
}


export function convertDate(date) {
    date = date.substring(0, date.length-10);
    
    return date;
}
